import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';

function PubblicoImpiegoModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id === 11
    ? 'Incendio Fabbricato'
    : type.id === 'res_civile' && insuranceRequest.product.id === 12
      ? 'Salute'
      : type.id === 'res_civile' && insuranceRequest.product.id === 1000
        ? 'Res. Amministrativa e Amministrativo/Contabile'
        : type.name;

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Res. Amministrativa"
      wrapMainInCol
      riskRowCompanyGate
    />
  );
}

export default PubblicoImpiegoModalButtons;
